<template>
  <div class="dialog-box">
    <div class="box-title">各省</div>
    <div class="update-time">
      数据截止到  {{ time }}
    </div>
    <div class="top-box">
      <div :class="(index===0||index===1||index===2)?'box-item-top':'box-item'" v-for="(i,index) of dataList">
        <div class="image-box">
          <img height="100%" v-if="index===0||index===1||index===2"
            :src="`https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/top${index+1}.png`"
          />
          <span v-else>{{ index+1 }}</span>
        </div>
        <div>
          {{ i.name }}
        </div>
      </div>
      <div class="box-item" v-for="index of (10-dataList.length)" :key="index">
        <div class="image-box">
          <span></span>
        </div>
        <div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: [],
    },
    time: {
      type: String,
      default: '',
    }
  },
  name: 'MyTop',
  data() {
    return {
      title: 'Welcome to My Component',
      message: 'This is my custom component',
    };
  },
};
</script>
<style scoped>
  .dialog-box {
    width: 400px;
    height: calc(400px * (2096 / 1080));
    margin:0px;
    background: #CE1F26;
    background: url(https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport2026/wordTop.jpg) no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    font-size: 1rem;
  }
  .box-title {
    padding-top: 2%;
    padding-left: 10%;
  }
  .update-time {
    margin-top: 60%;
    text-align: center;
    font-size: 1rem;
    color: #fff;
    margin-bottom: 10px;
    /* text-shadow: 0px 0px 10px #fff,0px 0px 20px #fff,0px 0px 30px #fff; */
  }
  .top-box {
    background: #fff ;
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 0 20px 15px 20px;
    padding: 10px;
  }
  .box-item {
    flex: 1;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 5px;
  }
  .box-item-top {
    flex: 1;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 5px;
    border: none;
    padding: 2px 20px;
  }
  .box-item-top>div:nth-child(1){
    flex: 1;
  }
  .box-item-top>div:nth-child(2){
    width: 140px;
    text-align: center;
  }
  .box-item>div:nth-child(1){
    flex: 1;
  }
  .box-item>div:nth-child(2){
    width: 140px;
    text-align: center;
  }
  .top-box>div:nth-child(1){
    background: #FFD76F;
    border-radius: 5px;
  }
  .top-box>div:nth-child(2) {
    border-radius: 5px;
    background: #DCDCDC;
  }
  .top-box>div:nth-child(3) {
    border-radius: 5px;
    background: #FFC197;
  }
  .image-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
  }
  .image-box img{
    max-width: 30px;
    /* max-height: 50px; */
  }
  @media screen and (max-width: 768px) {
    .dialog-box {
      width: 92vw;
      height: calc(92vw * (2096 / 1080));
      font-size: 1.3rem;
    }
    .box-title {
      padding-top: 1.8%;
    }
    .update-time {
      margin-top: 62%;
      font-size: 1.3rem;
    }
    .top-box {
      font-size: 1.2rem;
    }
    .image-box img{
      max-width: 3rem;
    }
  }
  @media screen and (max-width: 550px) {
    .dialog-box {
      font-size: 1rem;
    }
    .box-title {
      padding-top: 1.5%;
    }
    .update-time {
      margin-top: 62%;
      font-size: 12px;
    }
    .box-item-top {
      padding: 0 20px;
    }
    .update-time {
      margin-top: 64%;
      font-size: 12px;
    }
    .top-box {
      font-size: 12px;
    }
    .image-box img{
      max-width: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/top.vue